import endpoints from 'shared/store/endpoints'
import { useQuery } from '@tanstack/react-query'
import { storageHttpClient } from 'shared/store/ws'

const useStaticStorelocator = () => {
    return useQuery({
        queryKey: ['storelocator'],
        staleTime: 1000 * 60,
        queryFn: () =>
            storageHttpClient
                .get(endpoints.storeLocator.static)
                .then(res => res.data)
    })
}

export { useStaticStorelocator }
